
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/u/[user]/feedback",
      function () {
        return require("private-next-pages/u/[user]/feedback.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/u/[user]/feedback"])
      });
    }
  